import { getRequest, postRequest } from "NetworkCall";
import {
  INSTANCE_URL,
  SELECT_APP_ICON,
  UPDATE_UNSAVED_STATUS,
} from "Constants";
import LocaleStrings from "Languages";

export var UPDATE_PROCESSING_STATUS = "UPDATE_PROCESSING_STATUS";
export var TEMPLATES_CONTENT = "TEMPLATES_CONTENT";
export var EVENT_SELECTED_TEMPLATE = "EVENT_SELECTED_TEMPLATE";
export var SELECT_REVEAL_ICON = "SELECT_REVEAL_ICON";
export var COUNTRY_LIST = "COUNTRY_LIST";
export var SUPPORTCHAT_UNREADCOUNT = "SUPPORTCHAT_UNREADCOUNT"; // Unread Count Notification

export function selectDashboardMenu(menuItem) {
  return {
    type: SELECT_APP_ICON,
    payload: menuItem,
  };
}

export function selectedRevealMenuIcon(menuItem) {
  return {
    type: SELECT_REVEAL_ICON,
    payload: menuItem,
  };
}

export function updateUnsavedChanges(isunsaved = true) {
  return {
    type: UPDATE_UNSAVED_STATUS,
    payload: isunsaved,
  };
}

//OBSOLETE
export function validateEmailFromDB(session, values, callback) {
  //NOT USED ~ Ved - 25/04/2019
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/adminuserevent?filter=(email=${values.email})&fields=*`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2, message: LocaleStrings.email_not_available });
        } else {
          dispatch(validateEmailFromSystemDB(session, values, callback));
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function checkemailinSytemDB(session, values, callback) {
  var body = {
    ...values,
    eventid: session.eventid,
  };

  var url = `${INSTANCE_URL}/api/v2/eventifyscript/checkUserEmailinsystemdb`;
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {}
    );
  };
}

export function validateEmailForAppUser(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=%28email=${values.email}%29AND%28eventid=${session.eventid}%29&fields=*`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2, message: LocaleStrings.email_not_available });
        } else {
          callback({ success: 1, message: LocaleStrings.email_available });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function validateEmailFromSystemDB(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=getdfid&email=${values.email}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        var dfid = data.dfid;
        if (dfid !== null) {
          callback({ success: 2, message: LocaleStrings.email_not_available });
        } else {
          callback({ success: 1, message: LocaleStrings.email_available });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateProcessing(isprocessing) {
  return { type: UPDATE_PROCESSING_STATUS, payload: isprocessing };
}

export function fetchCountries(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/countrylist?filter=(isactive=1)&order=country%20ASC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: COUNTRY_LIST, payload: { response: data.resource } });
      },
      (error) => {}
    );
  };
}

/**** Fetch Unread Count ****/
export function fetchUnreadcount(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/supportchat`;
  var body = { ...values, eventid: session.eventid };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: SUPPORTCHAT_UNREADCOUNT,
          data: response.resource.unreadcount,
        });
        callback({ error: 0, data: "" });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}
